// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const ChangeAmounts = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M12.5 4.5h-7v4h7z" />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.518 13.5v-9a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2"
    />
    <path
      fill="currentColor"
      d="M6.5 11.134a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25M9 11.134a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25M11.5 11.134a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25M6.5 13.139a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25M9 13.139a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25M11.5 13.139a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25"
    />
  </svg>
);
const ForwardRef = forwardRef(ChangeAmounts);
export default ForwardRef;
